import { LitElement, html } from 'lit-element';

class AppSideNav extends LitElement {
    static get properties() {
        return {
            content: { type: Array },
            activePage: { type: String }
        };
    }

    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }

    generateFilename = (categoryName, pageName, pageNumber) => {
        const categorySlug = categoryName
            .toLowerCase()
            .replace(/^\d+\.\s+/, '') // Remove leading numbers
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-');

        const pageSlug = pageName
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-');

        const filename = `${pageNumber}-${categorySlug}-${pageSlug}.html`;
        pageNumber++;
        return filename;
    };

    getPageNumber = (categoryName, pageName) => {
        // Count the pages until the current page
        let pageNumber = 1;
        let wasFound = false;
        return this.content.reduce((acc, category) => {
            if (!wasFound) {
                category.pages.forEach(page => {
                    if (page.page_name === pageName) {
                        wasFound = true;
                    }
                    if (!wasFound) {
                        pageNumber++;
                    }
                });
            }
            return pageNumber;
        }, pageNumber);
    };

    updated(changedProperties) {
        if (changedProperties.has('content')) {
            // The active element may be out of view, so we need to scroll to it
            const activeElement = document.querySelector('#main-nav .nav-list .nav-item a.active');
            if (activeElement) {
                // activeElement.scrollIntoView({ behavior: 'instant', block: 'center' });
                // the layout might not be updated yet, so we need to wait for the next tick
                setTimeout(() => {
                    activeElement.scrollIntoView({ behavior: 'instant', block: 'center' });
                }, 50);
            }
        }
    }

    render() {
        return html`
            <nav>
                ${this.content
                    ? this.content.map(
                          category => html`
                              <div class="section">
                                  <h3 class="section-title">${category.category_name}</h3>
                                  <ul class="nav-list">
                                      ${category.pages.map(
                                          page => html`
                                              <li class="nav-item">
                                                  <a
                                                      href="${this.generateFilename(
                                                          category.category_name,
                                                          page.page_name,
                                                          this.getPageNumber(category.category_name, page.page_name)
                                                      )}"
                                                      class="nav-link ${this.activePage === page.page_name
                                                          ? 'active'
                                                          : ''}"
                                                      tabindex="0"
                                                      aria-label="${page.page_name}"
                                                  >
                                                      ${page.page_name}
                                                  </a>
                                              </li>
                                          `
                                      )}
                                  </ul>
                              </div>
                          `
                      )
                    : html`<div>No content available</div>`}
            </nav>
        `;
    }
}

customElements.define('app-sidenav', AppSideNav);
